import { Component, OnInit, Input, OnChanges, AfterViewInit } from '@angular/core';
import { RecipeObject } from 'src/app/interfaces/recipe.interface';
import { AngularFireStorage } from '@angular/fire/storage';
import 'firebase/storage';
import { faLockAlt } from '@fortawesome/pro-regular-svg-icons'
import { Observable } from 'rxjs';

@Component({
  selector: 'app-recipe-list-item',
  templateUrl: './recipe-list-item.component.html',
  styleUrls: ['./recipe-list-item.component.scss']
})
export class RecipeListItemComponent implements  OnChanges {

  @Input() data: RecipeObject;

  faLockAlt = faLockAlt;
  imageURL: Observable<string | null>;

  constructor(private storage: AngularFireStorage) { }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if (this.data.images) {
      const ref = this.storage.ref(this.data.images.icon);
      this.imageURL = ref.getDownloadURL();
 
    }  
  }
}
